import React, { useEffect, useState, useRef } from "react";
import styled, { keyframes } from "styled-components";

import useDisplay from "../../../hooks/useDisplay";
import MainBtn from "../../atoms/button/mainBtn";
import LSRgH1HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import Step01 from "../../organisms/onboarding/step01";
import Step02 from "../../organisms/onboarding/step02";
import Step03 from "../../organisms/onboarding/step03";
import Step04 from "../../organisms/onboarding/step04";
import { useNavigate } from "react-router-dom";
import { route } from "../../../router/route";
import { useRecoilState } from "recoil";
import {
  onboardingState,
  onboardingUserTagState,
} from "../../../store/onboardingState";
import OnboardingApi from "../../../api/onboarding.api";
import { errorHandler } from "../../../util/errorHandler";

function OnboardingModal({ setVisiable, isScroll }) {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const containerRef = useRef(null);
  const scrollRef = useRef(null);

  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [onboardingStateAtom, setOnboardingStateAtom] =
    useRecoilState(onboardingState);
  const [onboardingUserTagStateAtom, setOnboardingUserTagStateAtom] =
    useRecoilState(onboardingUserTagState);

  useEffect(() => {
    const handleClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setVisiable(false);
      }
    };
    window.addEventListener("mousedown", handleClick);
    return () => window.removeEventListener("mousedown", handleClick);
  }, [setVisiable]);

  useEffect(() => {
    scrollRef.current?.scrollTo({ top: 0 });
  }, [step]);

  useEffect(() => {
    switch (step) {
      case 1:
        if (onboardingStateAtom.question01 && onboardingStateAtom.question02) {
          setBtnDisabled(false);
        } else {
          setBtnDisabled(true);
        }
        break;

      case 2:
        if (
          onboardingStateAtom.question03 &&
          onboardingStateAtom.question04 &&
          onboardingStateAtom.question05 &&
          onboardingStateAtom.question06
        ) {
          setBtnDisabled(false);
        } else {
          setBtnDisabled(true);
        }
        break;

      case 3:
        if (
          onboardingStateAtom.question07 &&
          onboardingStateAtom.question08 &&
          onboardingStateAtom.question09 &&
          onboardingStateAtom.question10
        ) {
          setBtnDisabled(false);
        } else {
          setBtnDisabled(true);
        }
        break;

      case 4:
        if (onboardingStateAtom.question11?.length > 0) {
          setBtnDisabled(false);
        } else {
          setBtnDisabled(true);
        }
        break;

      default:
        break;
    }
  }, [onboardingStateAtom, step]);

  useEffect(() => {
    if (!isScroll) {
      document.body.style.cssText = `
      position: fixed; 
      top: -${window.scrollY}px;
      overflow-y: hidden;
      width: 99%;`;
      return () => {
        const scrollY = document.body.style.top;
        document.body.style.cssText = "";
        window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
      };
    }
  }, [isScroll]);

  const formStepUI = () => {
    switch (step) {
      case 1:
        return <Step01 />;

      case 2:
        return <Step02 />;

      case 3:
        return <Step03 />;

      case 4:
        return <Step04 />;

      default:
        return <Step01 />;
    }
  };

  // 태그 목록
  const tags = [
    "지식",
    "실전",
    "직장인",
    "사업자",
    "대출 기초",
    "대출 중급",
    "부동산 기초",
    "부동산 중급",
    "재테크 기초",
    "재테크 중급",
    "경제 기초",
  ];

  // 결과를 저장할 객체 초기화
  const initialCounts = tags.reduce((acc, tag) => {
    acc[tag] = 0;
    return acc;
  }, {});

  const resgisterOnBoardingFunc = async () => {
    if (isSubmitting || btnDisabled) return;

    setIsSubmitting(true);
    try {
      // 데이터에서 모든 문자열 추출
      const allStrings = Object.values(onboardingUserTagStateAtom)
        .flat()
        .join(",");

      // ','로 나누어 모든 태그 추출
      const allTags = allStrings.split(",");

      // 태그 카운트 업데이트
      const counts = { ...initialCounts };
      allTags.forEach((tag) => {
        if (counts[tag] !== undefined) {
          counts[tag]++;
        }
      });

      const data = {
        answer: [
          onboardingStateAtom.question01,
          onboardingStateAtom.question02,
          onboardingStateAtom.question03,
          onboardingStateAtom.question04,
          onboardingStateAtom.question05,
          onboardingStateAtom.question06,
          onboardingStateAtom.question07,
          onboardingStateAtom.question08,
          onboardingStateAtom.question09,
          onboardingStateAtom.question10,
          onboardingStateAtom.question11.join(", "),
        ],
        userTagCounts: counts,
      };

      await OnboardingApi.register(data);
      setOnboardingStateAtom({});
      setOnboardingUserTagStateAtom({});
      navigate(route.lecture_onboarding_complete);
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <OnboardingModalWrapper $isSmall={isSmall}>
      <OnboardingModalContainer $isSmall={isSmall} ref={containerRef}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",

              justifyContent: "space-between",
              width: "100%",
              position: "relative",
              marginBottom: isMobile ? 10 : 22,
              paddingRight: isSmall ? 20 : 60,
            }}
          >
            {step > 1 ? (
              <div
                onClick={() => {
                  setStep(step - 1);
                }}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  cursor: "pointer",
                  paddingTop: isSmall ? 18 : 8,
                }}
              >
                <LSRgH1HeadLine
                  style={{
                    color: "#A4A8B1",
                    fontSize: isMobile ? 10 : 16,
                    lineHeight: isMobile ? "12px" : "22.4px",
                  }}
                >
                  {`< 이전으로`}
                </LSRgH1HeadLine>
              </div>
            ) : (
              <div />
            )}
            <img
              onClick={() => {
                setVisiable(false);
              }}
              style={{
                width: isMobile ? 14 : 18,
                height: isMobile ? 14 : 18,
                cursor: "pointer",
              }}
              src={"/assets/icons/close.png"}
              alt="close"
            />
          </div>

          <YScrollCard $isSmall={isSmall} ref={scrollRef}>
            {formStepUI()}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                marginTop: isMobile ? 30 : 80,
              }}
            >
              <MainBtn
                disabled={btnDisabled || isSubmitting}
                onClick={() => {
                  if (step === 4) {
                    resgisterOnBoardingFunc();
                    return;
                  }
                  setStep(step + 1);
                }}
                style={{
                  width: isMobile ? "100%" : 380,
                }}
              >
                <LSRgH1HeadLine
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                  }}
                >
                  {step === 4
                    ? isSubmitting
                      ? "추천 결과를 불러오는 중..."
                      : "강의 추천받기"
                    : "다음으로"}
                </LSRgH1HeadLine>
              </MainBtn>
            </div>
          </YScrollCard>
        </div>
      </OnboardingModalContainer>
    </OnboardingModalWrapper>
  );
}

export default OnboardingModal;

// 페이드인 효과 정의
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const OnboardingModalWrapper = styled.div`
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 70px 0; */
  padding: ${(props) => (props.$isSmall ? "0px 20px" : "70px 0px")};
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  z-index: 1000;
`;

const OnboardingModalContainer = styled.div`
  width: ${(props) => (props.$isSmall ? "100%" : "996px")};
  padding: ${(props) =>
    props.$isSmall ? "20px 0px 20px 20px" : "40px 0px 40px 60px"};
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 8px 8px 35px 0px rgba(0, 0, 0, 0.45);

  animation: ${fadeIn} 0.7s ease-out;
`;

const YScrollCard = styled.div`
  width: 100%;
  height: 700px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  padding-right: ${(props) => (props.$isSmall ? "20px" : "60px")};

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #8585ff;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 2550, 255, 0.1); /*스크롤바 뒷 배경 색상*/
    border-radius: 10px;
    box-shadow: inset 0px 0px 5px white;
  }
`;
